import { render, staticRenderFns } from "./SousMenuUm6p.vue?vue&type=template&id=590ef1be&scoped=true"
import script from "./SousMenuUm6p.vue?vue&type=script&lang=js"
export * from "./SousMenuUm6p.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/SousMenuUm6p.css?vue&type=style&index=0&id=590ef1be&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ef1be",
  null
  
)

export default component.exports